<div class="svg-icon" [innerHTML]="svg | async | safe : 'html'"></div>
